import $axios from '@/store/axios-instance.js';

export default {
    state: {
        clientTicketDictionaryList: null,
        clientTicketList: null,
        currentClientTicket: null,
    },
    mutations: {
        retrieveClientTicketDictionaryList(state, payload) {
            state.clientTicketDictionaryList = payload
        },
        retrieveClientTicketsList(state, payload) {
            state.clientTicketList = payload
        },
        retrieveClientTicket(state, payload) {
            state.currentClientTicket = payload
        },
        changeClientTicket(state, payload) {
            let entity = state.clientTicketList.tickets.find(function (item) {
                return item.id === payload.id
            })
            Object.assign(entity, payload);

            if(state.currentClientTicket && state.currentClientTicket.id === payload.id){
                Object.assign(state.currentClientTicket, payload);
            }
        },
        deleteClientTicket(state, payload) {
            if (state.clientTicketList.clientTickets) {
                let entityIndex = state.clientTicketList.clientTickets.findIndex(function (item) {
                    return item.id === payload
                })
                if (entityIndex > -1) {
                    state.clientTicketList.clientTickets.splice(entityIndex, 1)
                }
            }
        },
    },
    actions: {
        retrieveClientTicketDictionaryList(context) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('clientTickets/dictList')
                    .then(response => {
                        context.commit('retrieveClientTicketDictionaryList', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveClientTicketList(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('clients/null/tickets', {
                        params: payload
                    })
                    .then(response => {
                        context.commit('retrieveClientTicketsList', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveClientTicket(context, payload) {
            return new Promise((resolve, reject) => {
                if (!payload) {
                    context.commit('retrieveClientTicket', null)
                    resolve()
                } else {
                    $axios
                        .get(`clients/${payload.clientId}/tickets/${payload.tickedId}`)
                        .then(response => {
                            context.commit('retrieveClientTicket', response.data)

                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        clientTicketAssignManager(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .put(`clients/${payload.clientId}/tickets/${payload.tickedId}/assign`)
                    .then(response => {
                        context.commit('changeClientTicket', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        changeClientTicketStatus(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .put(`clients/${payload.clientId}/tickets/${payload.tickedId}`, {
                        ticketStatusId: payload.ticketStatusId
                    })
                    .then(response => {
                        context.commit('changeClientTicket', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
    },
    getters: {
        clientTicketList(state) {
            return state.clientTicketList ? state.clientTicketList.tickets : []
        },
        clientTicketListTotal(state) {
            return state.clientTicketList ? state.clientTicketList.ticketCount : 0
        },
        clientTicketDictionaryList(state) {
            return state.clientTicketDictionaryList
        },
        currentClientTicket(state) {
            return state.currentClientTicket
        },
    },
    modules: {}
}